import React from "react";

import styled from "@emotion/styled";

import Button, { ButtonColor } from "../../../../shared/NewForms/Button";

const Links = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
`;

const PageMeta = styled.div`
    margin-right: 20px;
    margin-left: 20px;
`;
export type iLinks = {
    first: string;
    last: string;
    next: null | string;
    prev: null | string;
};

export type iMeta = {
    current_page: number;
    from: number;
    last_page: number;
    per_page: number;
    to: number;
    total: number;
    links: {
        url: string | null;
        label: string;
        active: boolean;
    }[];
};

interface iProps {
    paginationLinks: iLinks;
    paginationMeta: iMeta;
    setPage: (value: number) => void;
}
const Pagination = ({ paginationLinks, paginationMeta, setPage }: iProps) => {
    const changeLocation = (param: string) => {
        const parts = param.replace("?", "").split("=");
        setPage(parseInt(parts[1]));
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };

    return (
        <Links>
            <Button
                extraSmall
                color={ButtonColor.blueOutline}
                onClick={() => changeLocation(paginationLinks.first)}
            >
                {"<<"}
            </Button>
            <Button
                disabled={paginationLinks.prev === null}
                extraSmall
                color={ButtonColor.blueOutline}
                onClick={() => {
                    if (paginationLinks.prev !== null) {
                        changeLocation(paginationLinks.prev);
                    }
                }}
            >
                {"<"}
            </Button>
            <PageMeta>
                Seite {paginationMeta.current_page} von{" "}
                {paginationMeta.last_page}
            </PageMeta>
            <Button
                disabled={paginationLinks.next === null}
                extraSmall
                color={ButtonColor.blueOutline}
                onClick={() => {
                    if (paginationLinks.next !== null) {
                        changeLocation(paginationLinks.next);
                    }
                }}
            >
                {">"}
            </Button>
            <Button
                extraSmall
                color={ButtonColor.blueOutline}
                onClick={() => changeLocation(paginationLinks.last)}
            >
                {">>"}
            </Button>
        </Links>
    );
};

export default Pagination;
